import './actual-and-planned.scss';
import React, { useState, useEffect } from 'react';
import { Table } from 'rsuite';
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  MouseSensor,
} from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { default as t } from '../../../utils/i18n';

// import { SortableItem } from './sortableItem';
import { SortableItem } from '../../atoms/sortableItem/sortableItem';
const { Column, HeaderCell, Cell } = Table;

function ActualAndPlanned(props) {
  const [tableData, setTableData] = useState([]);
  const [panels, setPanels] = useState([]);
  useEffect(() => {
    const tableDataArr = [];
    const kpiList = props?.kpiList?.length > 0 ? props?.kpiList : [];
    const planned = props?.data?.metrics;
    const metrics_total = props?.data?.reportData?.metrics_total;
    const benchMark = props?.data?.reportData?.benchmark;
    planned?.forEach(el => {
      let row = {};
      row.kpi = kpiList?.filter(x => x?.sys_id === el?.sys_id)[0];
      row.metric =
        row.kpi?.KPI_Metric +
        (row?.kpi?.data_type === 'CURRENCY' ? ' (' + props?.data?.currency + ')' : '');
      row.planned = (el.plannedValue || el.plannedValue === 0) ? !Number.isInteger(el.plannedValue)
        ? convertValue(el.plannedValue?.toFixed(2))
        : el.plannedValue : 'N/A';
      const actual = metrics_total?.filter(x => x?.key === el?.sys_id)[0]?.value.trim();
      row.actual = actual && convertValue(actual) || 'N/A';
      if (row.planned !=='N/A' && row.actual !== 'N/A') {
        row.difference = !Number.isInteger(+actual - +el.plannedValue)
          ? (+actual - +el.plannedValue)?.toFixed(2)
          : +actual - +el.plannedValue;
        row.difference = row.difference > 0 ? '+' + convertValue(row.difference) : convertValue(row.difference);
      } else {
        row.difference = 'N/A';
      }
      row.benchMark = benchMark?.[el?.sys_id] ? !Number.isInteger(benchMark?.[el?.sys_id])
        ? convertValue(benchMark?.[el?.sys_id]?.toFixed(2))
        : benchMark?.[el?.sys_id] : 'N/A' ;
        tableDataArr.push(row);
    });
    setTableData(tableDataArr);
    let commentary = [];
    props?.data?.reportData?.planned_actual_commentary_to_show?.forEach((list, index) =>
      commentary.push({
        id: index,
        content: list.value,
        editable: false,
        show_in_export: list.show_in_export,
      })
    );
    setPanels([...commentary]);
  }, []);

  const convertValue = (value) => {
    return Number(value)?.toLocaleString();
  }
  const MultiplePanels = () => {
    const mouseSensor = useSensor(MouseSensor, {
      activationConstraint: {
        distance: 10, // Enable sort function when dragging 10px   💡 here!!!
      },
    });
    const sensors = useSensors(mouseSensor);
    function handleDragEnd(event) {
      const { active, over } = event;
      if (active.id !== over.id) {
        const oldIndex = panels.findIndex(x => x.id === active.id);
        const newIndex = panels.findIndex(x => x.id === over.id);
        const newArray = arrayMove(panels, oldIndex, newIndex);
        updatePanelsData(newArray);
      }
    }

    const updatePanelsData = (comentryData, type = '') => {
      console.log(comentryData);
      setPanels(comentryData);
      if (type !== 'edit') {
        props?.updateReportPreference('planned_actual_commentary', comentryData);
      }
    };

    return (
      <>
        {props?.isEdit ? (
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
            autoScroll={false}
          >
            <SortableContext items={panels} strategy={verticalListSortingStrategy}>
              {panels.map(item => (
                <SortableItem
                  data={item}
                  isEdit={props?.isEdit}
                  panels={panels}
                  fromSnapShot={props?.fromSnapShot}
                  setPanels={(data, type) => updatePanelsData(data, type)}
                />
              ))}
            </SortableContext>
          </DndContext>
        ) : (
          <div>
            {panels.map(item =>
              !item?.show_in_export && props?.fromSnapShot ? (
                ''
              ) : (
                <SortableItem
                  data={item}
                  isEdit={props?.isEdit}
                  panels={panels}
                  setPanels={(data, type) => updatePanelsData(data, type)}
                />
              )
            )}
          </div>
        )}
      </>
    );
  };
  return (
    <div className="final-report-main-container">
      <div className="table-Box actual">
        <Table
          bordered
          width={1100}
          data={tableData}
          autoHeight
          onRowClick={rowData => {
            console.log(rowData);
          }}
          wordWrap={props?.fromSnapShot}
        >
          <Column width={300}>
            <HeaderCell>{t('reportTable.text.kpi')}</HeaderCell>
            <Cell>
              {rowData => {
                return <span  className={rowData?.metric === 'N/A' ? 'notAvailableText':''} title={rowData?.metric}>{rowData?.metric}</span>;
              }}
            </Cell>
          </Column>
          <Column width={200}>
            <HeaderCell align='right'>{t('final.output.actual')}*</HeaderCell>
            <Cell align='right'>
              {rowData => {
                return <span className={rowData?.actual === 'N/A' ? 'notAvailableText':''} title={rowData?.actual}>{rowData?.actual}</span>;
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell align='right'>{t('final.output.planned')}</HeaderCell>
            <Cell align='right'>
              {rowData => {
                return <span className={rowData?.planned === 'N/A' ? 'notAvailableText':''} title={rowData?.planned}>{rowData?.planned}</span>;
              }}
            </Cell>
          </Column>
          <Column width={200}>
            <HeaderCell align='right'>{t('final.output.difference')}</HeaderCell>
            <Cell align='right'>
              {rowData => {
                return <span className={rowData?.difference === 'N/A' ? 'notAvailableText':''} title={rowData?.difference}>{rowData?.difference}</span>;
              }}
            </Cell>
          </Column>
          <Column width={200}>
            <HeaderCell align='right'>{t('final.output.benchmark.value')}</HeaderCell>
            <Cell align='right'>
              {rowData => {
                return <span className={rowData?.benchMark === 'N/A' ? 'notAvailableText':''} title={rowData?.benchMark}>{rowData?.benchMark}</span>;
              }}
            </Cell>
          </Column>
        </Table>
        <span className='totalValueNote'><span className='boldText'>*</span>{t('final.output.totalNoteWarning')} </span>
        <div className='totalValueNote'><span className='boldText'> <i className="eva eva-info-outline"></i></span>{t('report.output.insights.actual.planned.note')} </div>
      </div>
      {panels?.length > 0 ? (
        <div className="insights">
          <h3>{t('final.output.insights.title')}</h3>
          <MultiplePanels />
          <div className='the-insights'><span className='high-light'>*</span>{t('report.output.insights.note')} </div>
        </div>
      ) : (
        <div className="insights">
        <h3>{t('final.output.insights.title')}</h3>
        <p className='no-insights'>{t('final.output.no.insights')}</p>
        </div>
      )}
    </div>
  );
}

export default ActualAndPlanned;
